export const normalizeManufacturerEmails = (
  email?: string | string[] | null,
): string[] => {
  if (!email) {
    return [];
  }

  if (Array.isArray(email)) {
    return email.map((item) => item.trim()).filter(Boolean);
  }

  return email
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
};

export const formatManufacturerEmails = (email?: string | string[] | null) =>
  normalizeManufacturerEmails(email).join(', ');

export const parseEmailList = (value: string) =>
  value
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);

export const getPurchaseOrderManufacturerEmails = (
  purchaseOrder?: {
    overrideManufacturerEmails?: string[] | null;
    manufacturer?: { email?: string | string[] | null };
  } | null,
  manufacturerEmail?: string | string[] | null,
) => {
  if (purchaseOrder?.overrideManufacturerEmails != null) {
    return normalizeManufacturerEmails(
      purchaseOrder.overrideManufacturerEmails,
    );
  }

  return normalizeManufacturerEmails(
    manufacturerEmail ?? purchaseOrder?.manufacturer?.email,
  );
};
